import { LOCAL_STORAGE_PERMISSIONS } from '../../consts/common'

class PermissionManager {
    constructor() {
      this.loadPermissions()
    }

    // Method to load permissions from localStorage
    loadPermissions() {
      const permissions = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)) || {}
      this.features = permissions.features || {}
      this.crud = permissions.crud || []
      this.superAdmin = this.hasPermissionForFeature('super')
      this.allowed = localStorage.getItem('allowed') === 'true'
    }

    hasPermissionForTab(assetId, type) {
      return this.superAdmin || this.hasObjectPermission(assetId, type)
    }

    // Check if user has permission for a specific feature
    hasPermissionForFeature(featureName) {
      return this.superAdmin || this.crud.includes(featureName.toLowerCase())
    }

    isAdmin() {
      return this.superAdmin
    }

    // Check if user is allowed to access the admin dashboard
    isAllowedToAccessAdminDashboard() {
      return this.superAdmin || this.hasPermissionForFeature('menu') || this.crud.length > 0
    }

    // Update 'allowed' status based on permissions
    checkQuickViewPermission(setAllowed, permissions) {
      const canView = permissions.some(
        (permission) => permission.split('.')[1] === 'view'
      )
      setAllowed(canView)
      localStorage.setItem('allowed', canView)
      this.allowed = canView
    }

    hasObjectPermission(objectId, permissionType) {
      const permissionsString = localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)
      if (!permissionsString) return false

      const permissions = JSON.parse(permissionsString)

      const objectPermissions = permissions[objectId]
      if (!objectPermissions) return false

      return objectPermissions.some(permission => {
        const action = permission.split('.')[1]
        return action === permissionType
      })
    }

    hasObjectTypePermission(objectType, permissionType)
    {
      const permissionsString = localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)
      if (!permissionsString) return false

      const objectPermissions = JSON.parse(permissionsString)

      for (const objectId in objectPermissions) {
        const permissions = objectPermissions[objectId]
        if (!Array.isArray(permissions)) continue

        for (const permission of permissions) {
          const [type, action] = permission.split('.')

          if (type.toLowerCase() === objectType.toLowerCase())
            if (action.toLowerCase() === permissionType.toLowerCase())
              return true
        }
      }
      return false
    }

    updatePermissionsFromAPIResponse(responseData) {
      let permissionArray = {}

      let dataItems = []
      if (Array.isArray(responseData.data)) {
        dataItems = responseData.data
      } else if (typeof responseData.data === 'object' && responseData.data !== null) {
        dataItems = [responseData.data]
      }

      dataItems.forEach((item) => {
        if (item.id && Array.isArray(item.__permissions__)) {
          permissionArray[item.id] = item.__permissions__
        }
      })

      if (Object.keys(permissionArray).length > 0) {
        const existingPermissionsString = localStorage.getItem(LOCAL_STORAGE_PERMISSIONS)
        const existingPermissions = existingPermissionsString
          ? JSON.parse(existingPermissionsString)
          : {}

        const mergedPermissions = { ...existingPermissions, ...permissionArray }

        localStorage.setItem(LOCAL_STORAGE_PERMISSIONS, JSON.stringify(mergedPermissions))
      }
    }
  }

  const permissionManager = new PermissionManager()

  export default permissionManager
